/**
 * interactiveBlocks.tsx — Blocos interativos oficiais na tela do editor
 *
 * O desenho NÃO é reescrito aqui: o editor usa exatamente o mesmo módulo que
 * gera a página publicada (`interactive.ts`). Isso garante que a prévia e o que
 * vai ao ar sejam idênticos, sem manutenção em dobro.
 *
 * No editor o comportamento (abas, carrossel, contador) fica parado de
 * propósito: o que interessa é ver o desenho. O comportamento entra somente na
 * página publicada, e vem de um único arquivo escrito por nós.
 *
 * RELEASE: v1.0.0 - 2026-09-11 - Versão inicial (biblioteca própria, Fases 3 e 4)
 */

import {
  listStudioInteractiveBlocks,
  renderStudioInteractiveBlock,
} from '@/lib/studio/core/interactive';
import React from 'react';
import type { StudioWebBlockComponent, StudioWebBlockProps } from './types';

/** Cria o componente React de um bloco interativo a partir do módulo único. */
function criarComponente(tipo: string): StudioWebBlockComponent {
  const Componente = ({ node }: StudioWebBlockProps) => {
    const html = React.useMemo(
      () =>
        renderStudioInteractiveBlock(
          tipo,
          (node?.props ?? {}) as Record<string, unknown>,
          'editor',
        ),
      [node?.props],
    );
    if (!html) return null;
    // Conteúdo gerado pelo nosso próprio compilador (nunca HTML do usuário sem
    // escape): todo texto passa por `esc()` dentro do módulo único.
    return <div dangerouslySetInnerHTML={{ __html: html }} />;
  };
  Componente.displayName = `StudioInteractive(${tipo})`;
  return Componente;
}

/** Mapa pronto: chave do bloco -> componente React. */
export const STUDIO_INTERACTIVE_WEB_BLOCKS: Array<[string, StudioWebBlockComponent]> =
  listStudioInteractiveBlocks().map((chave) => [chave, criarComponente(chave)]);
